import { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";

const AddFlowConfig = () => {
    const [flow, setFlow] = useState({
        flow_name: "",
        flow_header: "",
        flow_body: "",
        flow_id: "",
        flow_cta: "",
        flow_mode: "",
        flow_action: "",
        flow_footer: ""
    });
    const errRef = useRef();
    const [errMsg, setErrMsg] = useState("");

    const { auth } = useAuth();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosPrivate.post("/flow-configs", flow, {headers: {Authorization: "Bearer " + auth.accessToken}});
            navigate("/configs");
        } catch(err) {
            console.log(err);
            if (!err?.response) {
                setErrMsg("No Server Response");
            } else if (err.response?.status === 400) {
                setErrMsg(err.response.data?.detail);
            } else if (err.response?.status === 401) {
                setErrMsg("Unauthorized");
            } else {
                setErrMsg("Request Failed");
            }
            errRef.current.focus();
        }
    }

    const onChange = (e) => {
        setFlow(curr => ({...curr, [e.target.id]: e.target.value}))
    }

    return (
        <div>
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Add Flow Config</span>
                </span>
            </div>
            <div style={{paddingBottom:'1.5rem'}}>
                <Link to="/configs">
                    <strong className="rounded border border-[#f3f4f7] bg-[#f3f4f7] px-3 py-1.5 text-[13px] font-medium text-black">
                        Back
                    </strong>
                </Link>
            </div>
            <p style={errMsg?{padding:"0.75rem", marginBottom:'1rem',background:'#F8B4B4', fontSize:'14px', borderRadius:'7px', color:'#808080'}:null} ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
            <form onSubmit={handleSubmit}>
                <div style={{display:'grid', rowGap: '1rem'}}>
                    <div>
                        <label for="flow_name" class="sr-only">Flow Name</label>
                        <select id="flow_name" value={flow.flow_name} onChange={onChange} class="block py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                            <option selected>Choose Flow Name</option>
                            <option value="REGISTRATION">REGISTRATION</option>
                            <option value="CALCULATOR">CALCULATOR</option>
                            <option value="SETPIN">SETPIN</option>
                            <option value="RESET_PIN">RESET_PIN</option>
                            <option value="START_1">START_1</option>
                            <option value="START_2">START_2</option>
                            <option value="RECOVER">RECOVER</option>
                            <option value="FAQ">FAQ</option>
                            <option value="CONTACT">CONTACT</option>
                            <option value="LOAN_APP">LOAN_APP</option>
                            <option value="LOAN_LIST">LOAN_LIST</option>
                            <option value="QUOTE">QUOTE</option>
                        </select>
                    </div>
                    <div>
                    <label htmlFor="flow_header" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                        <input
                            id="flow_header" 
                            value={flow.flow_header} 
                            onChange={onChange} 
                            required
                            placeholder="Flow Header"
                            className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                        />
                        <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                            Flow Header
                        </span>
                    </label>
                    </div>

                    <div>
                        <label htmlFor="flow_body" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                id="flow_body" 
                                value={flow.flow_body} 
                                onChange={onChange} required
                                placeholder="Flow Body"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Flow Body
                            </span>
                        </label>
                    </div>

                    <div>
                        <label htmlFor="flow_id" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                id="flow_id"
                                autoComplete="off"
                                onChange={onChange}
                                value={flow.flow_id}
                                required
                                placeholder="Flow ID"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Flow ID
                            </span>
                        </label>
                    </div>

                    <div>
                        <label htmlFor="flow_cta" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                        <input
                            type="text"
                            id="flow_cta"
                            autoComplete="off"
                            onChange={onChange}
                            value={flow.flow_cta}
                            required
                            placeholder="Flow CTA"
                            className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                        />
                        <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                            Flow CTA
                        </span>
                        </label>
                    </div>

                    <div>
                        <label for="flow_mode" class="sr-only">Flow Name</label>
                        <select id="flow_mode" value={flow.flow_mode} onChange={onChange} class="block py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                            <option selected>Choose Flow Mode</option>
                            <option value="draft">Draft</option>
                            <option value="published">Published</option>
                        </select>
                    </div>

                    <div>
                        <label for="flow_action" class="sr-only">Flow Action</label>
                        <select id="flow_action" value={flow.flow_action} onChange={onChange} class="block py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                            <option selected>Choose Flow Action</option>
                            <option value="data_exchange">data_exchange</option>
                            <option value="complete">complete</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="flow_footer" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                id="flow_footer"
                                autoComplete="off"
                                onChange={onChange}
                                value={flow.flow_footer}
                                placeholder="Flow ID"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Flow Footer
                            </span>
                        </label>
                    </div>
                    
                </div>
                <div style={{display:'flex', paddingTop:'2rem', justifyContent:'end'}}>
                    <button>
                        <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                            Submit
                        </strong>
                    </button>
                </div>
            </form>
        </div> 
    )
}

export default AddFlowConfig;